export const FLAG_DEFAULTS = {
  subscription: false,
  'time-off': false,
  // Job titles are hidden until their customisation depth is refined; job roles stay on
  'job-titles': false,
  // Skills everywhere they are shown, picked or managed; job roles do their work meanwhile
  skills: false,

  /*
  | Release 2026-10-15: features the new API can't support yet. Each stays
  | off until its backend work lands (see release-kit reports/web-20).
  */
  // Onboarding draft API returns {draft} only and PUT is 204; the wizard throws on a new org
  onboarding: false,
  // Activity rows request includes[]=shift.area, which 500s (ShiftOfferRevisedTransformer), and export sends GET to a POST route
  'employee-activity': false,
  // BroadcastController@index ignores `name`, so the "Search by content" box does nothing
  'broadcast-search': false,
  // Building create writes old address columns (500); update only accepts a nested address, so edits are dropped
  'building-address': false,
  // Time-off index filters dates[] on leave_date, which new requests leave null, so clashes are never found
  'time-off-conflicts': false,
  // On: the time-off index filters status=0 (pending) since the API's filled('status') fix (B20)
  'time-off-pending-filter': true,
  // No timesheet approve/reopen endpoint; the shift drawer offered "Approve timesheet" for completed shifts
  'timesheet-approval': false,
  // ShiftPresetController@index ignores `name`, so the presets search box does nothing
  'shift-preset-search': false,
  // No `groups` table in the release database (struct-29, B21): Settings > Groups would 500
  groups: false,
  // Per-site switch only the operator changes (changes-1019 CHG-28); GET orgs/{org}/config feature_flags.sms
  sms: false,
} satisfies Record<string, boolean>

export type FeatureFlag = keyof typeof FLAG_DEFAULTS
